import React from 'react';
import { motion } from 'framer-motion';
import { Award, Clock, Users, ShieldCheck } from 'lucide-react';
const stats = [{
  icon: Award,
  number: '6+ let',
  label: 'Izkušenj na trgu'
}, {
  icon: Clock,
  number: '90 %',
  label: 'Uspešnost prodaje'
}, {
  icon: Users,
  number: '100.000+',
  label: 'Registriranih kupcev'
}, {
  icon: ShieldCheck,
  number: '8.500+',
  label: 'Zaključenih dražb'
}];
export function StatsStrip() {
  return <section className="container mx-auto px-4 py-8" data-id="element-331">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-332">
        {stats.map((stat, index) => <motion.div key={stat.label} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow text-center" data-id="element-333">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-[#1EB6E8]/10 rounded-lg mb-4" data-id="element-334">
              <stat.icon className="w-6 h-6 text-[#1EB6E8]" data-id="element-335" />
            </div>
            <div className="text-3xl font-bold text-slate-900 mb-2" data-id="element-336">
              {stat.number}
            </div>
            <div className="text-slate-600 text-sm" data-id="element-337">{stat.label}</div>
          </motion.div>)}
      </div>
    </section>;
}